module.exports = __webpack_public_path__ + "img/facebook-pages.bfbdecf4.svg";